import axios from 'axios'
import { v4 as uuidv4 } from 'uuid';

export default {
    namespaced: true,
    state: () => ({
        url: '',
        user: {
            id: '',
            identities: {
                houseKeyNew: '',
                emailAddress: '',
                accountId: '',
            },
            attributes: {
                houseKeyNew: '',
                emailAddress: '',
                accountId: '',
                cartDate: '',
                cartURL: '',
                cartItem: '',
                cartItemPrice: '',
                allConnectId: '',
                street: '',
                apt: '',
                city: '',
                state: '',
                zip: '',
                country: '',
                householdInternetUse: '',
                numberInternetUser: '',
                homeSize: ''
            },
        },
        source: {
            contentZones: [],
        },

        campaignResponses: [],
    }),
    getters: {

    },
    mutations: {
        SET_URL(state, value) {
            state.url = value
        },
        SET_USER(state, value) {
            state.user = {...state.user,...value}
        },
        SET_USER_ID(state, value) {
            state.user.id = value
        },
        SET_CAMPAIGN_RESPONSES(state, value) {
            state.campaignResponses = [...state.campaignResponses.filter((c) => !value.find(v => v.templateNames[0] === c.templateNames[0])),...value]
        },
        UPDATE_CONTENT_ZONE(state, value) {
            state.source.contentZones = [...state.source.contentZones, ...value]
        },
    },
    actions: {
        initialize({ commit, state, dispatch }, { url }) {
            commit('SET_URL', url)
            if (state.user.id === ''){
                commit('SET_USER_ID', uuidv4())
            }
            if (window.location.href === window.location.origin + '/') {

                dispatch('ping', {
                    eventName: 'VIEW_HOME',
                    payload: {
                        source: {
                            contentZones: state.source.contentZones,
                            pageType: 'home',
                            url: window.location.href,
                            urlReferrer: document.referrer.includes('android-app://') ? '' : document.referrer,
                            locale: 'en_US',
                        },
                    },
                })
            } else if (['/internet', '/internet-tv', '/internet-voice', '/wifi-your-way'].indexOf(window.location.pathname, 0) > -1){
                dispatch('ping', {
                    eventName: 'VIEW_CATEGORY',
                    payload: {
                        source: {
                            contentZones: state.source.contentZones,
                            pageType: 'category',
                            url: window.location.href,
                            urlReferrer: document.referrer.includes('android-app://') ? '' : document.referrer,
                            locale: 'en_US',
                        },
                        catalog: {
                            Category: {
                                _id: {'/internet': 'internet', '/internet-tv': 'internet-tv', '/internet-voice': 'internet-voice', '/wifi-your-way': 'internet-equipment'}[window.location.pathname],
                            },
                        },
                    },
                })
            } else if (!(window.location.pathname).includes('/checkout')){
                dispatch('ping', {
                    eventName: 'VIEW_PAGE',
                    payload: {
                        source: {
                            contentZones: state.source.contentZones,
                            pageType: 'default',
                            url: window.location.href,
                            urlReferrer: document.referrer.includes('android-app://') ? '' : document.referrer,
                            locale: 'en_US',
                        },
                    },
                })
            }
        },
        ping({ commit, state, rootState }, { eventName = null, payload = {} }) {
            const event = {
                CHECK_AVAILABILITY: {
                    action: 'Check Availability',
                    source: {
                        contentZones: state.source.contentZones,
                        pageType: 'default',
                        url: window.location.href,
                        urlReferrer: document.referrer,
                        locale: 'en_US',
                    },
                },
                VIEW_HOME: {
                    action: 'Visit home page',
                },
                VIEW_PAGE: {
                    action: 'Visit page',
                },
                VIEW_CATEGORY: {
                    action: 'Visit product category',
                    itemAction: 'View Category',
                },
                VIEW_PRODUCT: {
                    action: 'View Product',
                    itemAction: 'View Item',
                },
                FILL_CALCULATOR: {
                    action: 'Fill Calculator',
                },
                ADD_TO_CART: {
                    action: 'Add product to cart',
                    itemAction: 'Add To Cart',
                },
                VIEW_UPDATE_CART: {
                    action: 'View Cart',
                    itemAction: 'View Cart',
                },
                PURCHASE: {
                    action: 'Made a purchase',
                    itemAction: 'Purchase',
                },
                CAMPAIGN_IMPRESSION: {
                    action: 'Campaign Impression'
                },
            }[eventName]

            const removeEmptyStrings = (obj) => {
                Object.keys(obj).forEach(i => (obj[i] && typeof obj[i] === 'object') && removeEmptyStrings(obj[i]) || (obj[i] === "") && delete obj[i]);
                return obj;
            };

            if (!event) return false

            if (eventName === 'CHECK_AVAILABILITY' && payload.user) {
                commit('SET_USER', payload.user)
            }

            if (state.user.id === '') {
                console.error('Personalization: ID is required.')
                return false
            }

            let data = {
                ...event,
                ...payload,
                user: {
                    ...state.user,
                    identities: {
                        ...state.user.identities,
                        ...(payload.user?.identities || {}),
                    },
                    attributes: {
                        ...state.user.attributes,
                        ...(payload.user?.attributes || {}),
                    },
                },
            }

            const urlParams = new URLSearchParams(window.location.search)
            if (urlParams.has('testCampaign')) {
                data.user.attributes.testCampaign = urlParams.get('testCampaign')
            }

            data = removeEmptyStrings(data);

            // [BZL-970] Send a blank value by default and pass the testMarket parameter when it's in the URL
            data.user.attributes.testMarket = '';
            if (urlParams.has('testMarket')) {
                data.user.attributes.testMarket = urlParams.get('testMarket')
            }

            if ((urlParams.has('mt') || rootState.forcedMarket.marketType) &&  data.action !== 'Check Availability') {
                data.user.attributes.testMarket = urlParams.get('mt') ?? rootState.forcedMarket.marketType
            }

            // APPARENTLY the purchase event is the one call that actually requires
            // empty strings to be sent. Let's re-add them after they're removed
            // above
            if (eventName === 'PURCHASE') {
                data.user.attributes.cartURL = payload.user.attributes.cartURL;
                data.user.attributes.cartItem = payload.user.attributes.cartItem;
                data.user.attributes.cartItemPrice = payload.user.attributes.cartItemPrice;
                data.user.attributes.cartDate = payload.user.attributes.cartDate;
            }

            axios.post(state.url, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With' : 'XMLHttpRequest',
                }
            })
                .then(r => {
                    if (r.data.campaignResponses?.length) {
                        commit('SET_CAMPAIGN_RESPONSES', r.data.campaignResponses)
                    }
                })
                .catch(error => console.error(eventName, error))

            return true
        },
        updateContentZone({ commit }, payload) {
            commit('UPDATE_CONTENT_ZONE', payload)
        }
    },
}
